// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import ErrorPage from 'components/pages/Error';

const messages = {
  syncbakError: {
    id: 'error.message.syncbakStartup',
    description: 'syncbak error',
  },
  syncbakCode: {
    id: 'error.message.syncbakStartupCode',
    description: 'syncbak error code',
  },
};

const SyncbakError = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const intl = useIntl();

  const syncbakError = intl.formatMessage(messages.syncbakError);
  const syncbakCode = code
    ? intl.formatMessage(messages.syncbakCode, { code })
    : null;

  return (
    <ErrorPage
      message={
        <React.Fragment>
          <div>{syncbakError}</div>
          {syncbakCode}
        </React.Fragment>
      }
    />
  );
};

export default SyncbakError;
